var map = {
	"./AsusNexus7.png": "43b9",
	"./GeneralMobileGM8.png": "0a4b",
	"./GeneralMobileGM9Pro.png": "7747",
	"./GooglePixelC.png": "abbb",
	"./HuaweiMate20Lite.png": "1fc9",
	"./HuaweiNove9.png": "2290",
	"./HuaweiP9Lite.png": "0bad",
	"./LG.png": "ecc6",
	"./OppoAX7.png": "85ec",
	"./OppoReno4Lite.png": "4abc",
	"./ReederP13BlueMaxLite.png": "6940",
	"./SamsungGalaxyA32.png": "85cf",
	"./SamsungGalaxyA71.png": "b0e0",
	"./SamsungGalaxyA72017.png": "86a0",
	"./SamsungGalaxyM22.png": "fdb6",
	"./SamsungGalaxyM23.png": "bce7",
	"./SamsungGalaxyM32.png": "71a8",
	"./SamsungGalaxyNote10Lite.png": "49ea",
	"./SamsungGalaxyNote20.png": "2c7d",
	"./SamsungGalaxyOn7Prime.png": "a944",
	"./SamsungGalaxyS10.png": "6178",
	"./SamsungGalaxyS10E.png": "89f9",
	"./SamsungGalaxyS10Lite.png": "f5f3",
	"./SamsungGalaxyS20.png": "ea3c",
	"./SamsungGalaxyS20Plus.png": "f5a0",
	"./SamsungGalaxyS21.png": "2765",
	"./SamsungGalaxyS8Plus.jpg": "3a7e",
	"./SamsungGalaxyS9Plus.png": "2628",
	"./SamsungGalaxyTab4.png": "2366",
	"./SamsungGalaxyTab8A.jpeg": "5429",
	"./SonyXperiaXA1.png": "d65e",
	"./XiaomiMi11Lite.png": "86d6",
	"./XiaomiRedmiNote11.png": "2979",
	"./XiaomiRedmiNote8.png": "ebcd",
	"./api.svg": "4912",
	"./apple-ipad-9.png": "786d",
	"./apple-iphone-11-pro.jpg": "3825",
	"./apple-iphone-11-pro.png": "728b",
	"./apple-iphone-11-pro2.jpg": "7447",
	"./apple-iphone-12-pro-max.png": "a293",
	"./apple-iphone-12.png": "34b5",
	"./apple-iphone-5s.jpg": "3fa2",
	"./apple-iphone-5s.png": "caa7",
	"./apple-iphone-6.jpg": "609b",
	"./apple-iphone-6.png": "f54f",
	"./apple-iphone-6s.jpg": "b928",
	"./apple-iphone-6s.png": "d8da",
	"./apple-iphone-7.jpg": "4341",
	"./apple-iphone-7.png": "257e",
	"./apple-iphone-8.jpg": "159d",
	"./apple-iphone-8.png": "a8a0",
	"./apple-iphone-x.jpg": "d8ee",
	"./apple-iphone-x.png": "4043",
	"./apple-iphone-xs.jpg": "7368",
	"./apple-iphone-xs.png": "f03b",
	"./asus-zenfone-live.jpg": "7426",
	"./asus-zenfone-live.png": "74b0",
	"./chrome.svg": "ab7a",
	"./default-unknow-phone.jpeg": "647d",
	"./desktop.svg": "cfcf",
	"./edge.svg": "a945",
	"./firefox.svg": "7bc7",
	"./generalmobile-gm5-plus.jpg": "b994",
	"./generalmobile-gm5-plus.png": "7841",
	"./generalmobile-gm8.jpg": "aa4d",
	"./generalmobile-gm8.png": "1151",
	"./google.png": "f859",
	"./google_old.png": "72eb",
	"./htc-desire-10.jpg": "a862",
	"./htc-desire-10.png": "8bac",
	"./huawei-p20-pro.jpg": "5de0",
	"./huawei-p20-pro.png": "dee4",
	"./huawei-p30.png": "6ac6",
	"./huawei-p9-lite.jpg": "9a9c",
	"./huawei-p9-lite.png": "f113",
	"./huawei-y6.jpg": "089f",
	"./huawei-y6.png": "cafae",
	"./iPad9.jpg": "6db1",
	"./iPadMini4.png": "1a77",
	"./iPhone11.png": "0b59",
	"./iPhone12.png": "0c4d",
	"./iPhone12Mini.png": "be50",
	"./iPhone12Pro.png": "3611",
	"./iPhone12ProMax.png": "4f61",
	"./iPhone13.png": "ade5",
	"./iPhone13Pro.png": "ecb9",
	"./iPhone13ProMax.png": "1d90",
	"./iPhone14.png": "4f09",
	"./iPhone14Pro.png": "418c",
	"./iPhone14ProMax.png": "d5c3",
	"./iPhone6S.png": "12dd",
	"./iPhone6SPlus.png": "98e6",
	"./iPhone7.png": "b0dd",
	"./iPhone7Plus.png": "ab09",
	"./iPhone8.png": "7af1",
	"./iPhone8Plus-1.png": "2889",
	"./iPhone8Plus-2.png": "0d9f",
	"./iPhoneSE2020.png": "afee",
	"./iPhoneX.png": "9886",
	"./iPhoneXR.jpg": "41b6",
	"./iPhoneXS.png": "aaa4",
	"./iPhoneXSMax-1.png": "b5ca",
	"./iPhoneXSMax-2.png": "be3e",
	"./ipad-default.jpg": "b3a3",
	"./ipad.png": "02ad",
	"./lg-default.jpg": "1e58",
	"./motorola-default.jpg": "0099",
	"./motorola.png": "35f0",
	"./nokia-6.jpg": "21c2",
	"./nokia-6.png": "07cc",
	"./oneplus-default.jpeg": "6a9a",
	"./oneplus.png": "a6db",
	"./opera.svg": "187f",
	"./oppo-ax7.jpg": "2857",
	"./oppo-ax7.png": "081d",
	"./safari.svg": "8caf",
	"./samsung-galaxy-a20.jpg": "7d2f",
	"./samsung-galaxy-a20.png": "4fa6",
	"./samsung-galaxy-a30.jpg": "c639",
	"./samsung-galaxy-a30.png": "095e",
	"./samsung-galaxy-a31.png": "ee2d",
	"./samsung-galaxy-a5.jpg": "87d9",
	"./samsung-galaxy-a5.png": "319e",
	"./samsung-galaxy-a50.jpg": "0db7",
	"./samsung-galaxy-a50.png": "419f",
	"./samsung-galaxy-a52.png": "dd7a",
	"./samsung-galaxy-a7.jpg": "d7b5",
	"./samsung-galaxy-a7.png": "6eb8",
	"./samsung-galaxy-a70.jpg": "574a",
	"./samsung-galaxy-a70.png": "03b9",
	"./samsung-galaxy-e5.jpg": "7a6b",
	"./samsung-galaxy-e5.png": "822e",
	"./samsung-galaxy-grand2.jpg": "1d72",
	"./samsung-galaxy-grand2.png": "f5fa",
	"./samsung-galaxy-j7.jpg": "25c7",
	"./samsung-galaxy-j7.png": "62b8",
	"./samsung-galaxy-note4.jpg": "43f2",
	"./samsung-galaxy-note4.png": "18ff",
	"./samsung-galaxy-note8.jpg": "7f7f",
	"./samsung-galaxy-note8.png": "0a3b",
	"./samsung-galaxy-s10e.png": "1e1f",
	"./samsung-galaxy-s20-fe.png": "99c7",
	"./samsung-galaxy-s20.png": "dcff",
	"./samsung-galaxy-s3.jpg": "2255",
	"./samsung-galaxy-s3.png": "132a",
	"./samsung-galaxy-s6 copy.jpg": "e1ce",
	"./samsung-galaxy-s6 copy.png": "e950",
	"./samsung-galaxy-s6-edgeplus.jpg": "58ff",
	"./samsung-galaxy-s6-edgeplus.png": "674a",
	"./samsung-galaxy-s6.jpg": "ef34",
	"./samsung-galaxy-s6.png": "b117",
	"./samsung-galaxy-s7.jpg": "ebb8",
	"./samsung-galaxy-s7.png": "f7ba",
	"./samsung-galaxy-s8.jpg": "69f4",
	"./samsung-galaxy-s8.png": "4290",
	"./samsung-redmi-note-11.png": "c351",
	"./sony-xperia-xa1-ultra.jpg": "dd26",
	"./sony-xperia-xa1-ultra.png": "18a8",
	"./turkcell-t50.jpg": "2312",
	"./turkcell-t50.png": "5d15",
	"./turkcell-t60.jpg": "3266",
	"./turkcell-t60.png": "b80f",
	"./vestel-venus-v3.jpg": "38c8",
	"./vestel-venus-v3.png": "e8c9",
	"./xiaomi-mi-8.jpg": "8e41",
	"./xiaomi-mi-8.png": "53bd",
	"./xiaomi-redmi-note11-pro.png": "4cad",
	"./xiaomi-redmi-note9-pro.png": "8ef7",
	"./xiaomi.png": "4f87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9498";